import axiosIns from '../../../xaxios';
import { obtenerUrlAPIComisiones } from '../utils/funciones';

export default {
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones('categorias'), opciones);
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`categorias/${id}`));
  },
  async findCategoriaBaseEquivalente() {
    return await axiosIns.get(obtenerUrlAPIComisiones('categorias/base-equivalente'));
  },
};
